 
 <template lang="">
 
 <UserLayout  pageTitle="Gestione permessi">
      <template #page-content="props">
    
                    <!-- <v-card
                        class="form-card" 
                        outlined 
                        > -->
                        <FrmManagePermissions></FrmManagePermissions>
        
                    <!-- </v-card> -->
        </template>
 </UserLayout> 
</template>
 
 <script>
import UserLayout from "../layout/UserLayout";
import FrmManagePermissions from "../components/Management/FrmManagePermissions";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmManagePermissions,
    UserLayout,
  },
};
</script>
 <style lang="">
</style> 
